import axios from '../axios'
import { getParameterByName } from './../../utils/util'

var token = getParameterByName('token');

// 用法示例
var paramValue = getParameterByName('yourParamName');

const getBrandList = params => {
  return axios({
    url: '/recycle/product/brand/list',
    method: 'get',
    params
  })
}

const getModelList = params => {
  return axios({
    url: '/recycle/product/product/list',
    method: 'get',
    params
  })
}

const photoPolicyPutUpload = data => {
  return axios({
    url: '/file/upload-file',
    method: 'post',
    data
  })
}

const uploadDetectionAttachments = data => {
  return axios({
    url: '/yihuan/detection/upload-detection-attachments',
    method: 'post',
    data
  })
}

const orderDetail = data => {
  return axios({
    url: '/user/order/detail?token=' + token,
    method: 'post',
    data
  })
}

const uploadFile = data => {
  return axios({
    url: '/user/file/upload-file?token=' + token,
    method: 'post',
    data
  })
}

const uploadImg = (uploadUrl, formData) => {
  return axios({
    url: uploadUrl,
    method: 'post',
    data: formData,
    headers:{'Content-Type':'multipart/form-data'},
  })
}

// 上传文件
const policyPutUpload = (params) => {
  return axios({
    url: '/file/policyPostUpload',
    method: 'get',
    params
    // timeout: 1000 * 30
  })
}

const submit = data => {
  return axios({
    url: '/user/order/oldImeiPic/submit?token=' + token,
    method: 'post',
    data
  })
}

const getExpressBill = data => {
  return axios({
    url: '/user/logistics/getExpressBill/async?token='  + token,
    method: 'post',
    data
  })
}

const orderAccept = params => {
  return axios({
    url: '/user/order/accept?token=' + token,
    method: 'get',
    params
  })
}

const orderReject = params => {
  return axios({
    url: '/user/order/reject?token=' + token,
    method: 'get',
    params
  })
}

const getOldImeiPic = data => {
  return axios({
    url: '/user/order/oldImeiPic/get?token=' + token,
    method: 'post',
    data
  })
}


export {
  orderDetail,
  getBrandList,
  getModelList,
  photoPolicyPutUpload,
  uploadDetectionAttachments,
  uploadFile,
  submit,
  getExpressBill,
  orderAccept,
  orderReject,
  getOldImeiPic,
  uploadImg,
  policyPutUpload
}
